import { LAYOUTS, } from '@voltmoney/types';
import { BorderRadiusTokens, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignContent, StackAlignItems, StackJustifyContent, StackPositionType, StackType, StackWidth, TextAlignTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from "./types";
import { applyNow, goToInfo, goToInit, goToRegisterLeads, goToViewDetails, onChangeDimension } from "./actions";
import { CheckLimitInfoType, CONTEXT, minAllowedCreditLimit, NonEligiblePortfolioType, PortfolioType } from "../../configs/constants";
import { addCommasToNumber, getParameters, isMobile, roundDownToNearestHundred, sumObjectValues } from "../../configs/utils";
import sharedPropsService from "../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { Platform } from "react-native";
import { isLLa, showEditDetails, showLLABannerCard, showViewDetails, showWithdrawNowCta } from "./utils";
import SharedPropsService from '../../SharedPropsService';
import { initializeFirebase } from '../../configs/config';
const _isMobile = isMobile();
export const template = async (availableCreditLimit, totalPortfolio, eligiblePortfolio, eligibleLimit, dematPortfolioValue, isLockedPortfolioValue, isUnapprovedPortfolioValue, nonEligiblePortfolioValue, phone, pan, partnerAccountId, context, refCode, isCheckLimitMFC, isEligible, nonEligibleDisplayReason, allowDynamicLimitFromBEFlag, eligibleFlag, isJointHolderPortfolioValue) => ({
    layout: {
        id: ROUTE.CHECK_LIMIT_SUCCESS,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'CheckLimitSuccessMFRootStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        CheckLimitSuccessMFRootStack: {
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackTop', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackBottom', type: WIDGET.STACK },
            ],
            dimensionAction: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.ON_CHANGE_DIMENSION,
                payload: {}
            }
        },
        CheckLimitSuccessMFRootStackTop: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.Secondary_05,
            alignItems: StackAlignItems.center,
            padding: {
                all: SizeTypeTokens.XL
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackTopStack1', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackTopSpace0', type: WIDGET.SPACE },
                { id: 'CheckLimitSuccessMFRootStackAvailableLimit', type: WIDGET.STACK },
                // availableCreditLimit < minAllowedCreditLimit 
                !eligibleFlag ? { id: 'CheckLimitSuccessMFRootStackTopSpace1', type: WIDGET.SPACE } : {},
                // availableCreditLimit < minAllowedCreditLimit
                !eligibleFlag ? { id: 'CheckLimitSuccessMFRootStackLessThanAvailableLimit', type: WIDGET.STACK } : {},
                { id: 'CheckLimitSuccessMFRootStackTopSpace2', type: WIDGET.SPACE },
                { id: 'CheckLimitSuccessMFRootStackApplyNowStack', type: WIDGET.STACK },
            ]
        },
        CheckLimitSuccessMFRootStackTopStack1: {
            width: StackWidth.MATCH_PARENT,
            type: _isMobile ? StackType.column : StackType.row,
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            widgetItems: [
                // availableCreditLimit >= minAllowedCreditLimit 
                eligibleFlag ? { id: 'CheckLimitSuccessMFRootStack1', type: WIDGET.STACK } : {},
                { id: 'CheckLimitSuccessMFRootStackTopT2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStack1: {
            width: StackWidth.CONTENT,
            type: StackType.row,
            alignItems: StackAlignItems.center,
            widgetItems: [
                // {id: 'CheckLimitSuccessMFRootStack1Lottie1', type: WIDGET.LOTTIE},
                { id: 'CheckLimitSuccessMFRootStackTopT1', type: WIDGET.TEXT }
            ]
        },
        // CheckLimitSuccessMFRootStack1Lottie1: <LottieProps> {
        //   uri: LottieTokens.PartyPopper,
        //   size: LottieSizeTokens.Size28,
        //   aspectRatio: AspectRatioToken.A3_4,
        //   autoplay: true
        // },
        CheckLimitSuccessMFRootStackApplyNowStack: {
            width: StackWidth.CONTENT,
            maxWidth: _isMobile ? '100%' : 338,
            minWidth: _isMobile ? '100%' : 338,
            widgetItems: [
                { id: 'ApplyNow', type: WIDGET.BUTTON },
                context === 'PARTNER' ? { id: 'CheckLimitSuccessMFRootStackApplyNowStackSpace0', type: WIDGET.SPACE } : {},
                context === 'PARTNER' ? { id: 'CheckForNewUser', type: WIDGET.BUTTON } : {},
            ]
        },
        CheckForNewUser: {
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            label: "Check for new user",
            type: ButtonTypeTokens.LargeSoftFilled,
            width: ButtonWidthTypeToken.FULL,
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.GO_TO_INIT,
                payload: {},
            },
        },
        CheckLimitSuccessMFRootStackLessThanAvailableLimit: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            justifyContent: StackJustifyContent.center,
            alignContent: StackAlignContent.center,
            widgetItems: [
                { id: 'errorImageStack', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackLessThanAvailableLimitText1', type: WIDGET.TEXT }
            ]
        },
        errorImageStack: {
            type: StackType.column,
            position: StackPositionType.relative,
            positionConfig: {
                bottom: SizeTypeTokens.SM
            },
            widgetItems: [
                { id: "CheckLimitSuccessMFRootStackLessThanAvailableLimitIcon1", type: WIDGET.IMAGE },
                { id: "spaceMD", type: WIDGET.SPACE }
            ]
        },
        spaceMD: {
            size: SizeTypeTokens.XL
        },
        CheckLimitSuccessMFRootStackLessThanAvailableLimitIcon1: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/systemError.png',
            width: 24,
            height: 24
        },
        CheckLimitSuccessMFRootStackLessThanAvailableLimitText1: {
            label: allowDynamicLimitFromBEFlag
                ? `${nonEligibleDisplayReason}`
                : 'Please note that a minimum credit limit of ₹25,000 is required to apply for loan.',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: 24,
            numberOfLines: 2,
            textAlign: "left",
            color: ColorTokens.System_Error
        },
        CheckLimitSuccessMFRootStackBottom: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                all: SizeTypeTokens.XL
            },
            widgetItems: [
                context !== CONTEXT.PARTNER || showLLABannerCard({ refCode: refCode }) ? { id: 'CheckLimitLLABenefitCard', type: WIDGET.LLA_BENEFIT_CARD } : {},
                context !== CONTEXT.PARTNER || showLLABannerCard({ refCode: refCode }) ? { id: 'CheckLimitSuccessMFRootStackBottomSpace0', type: WIDGET.SPACE } : {},
                { id: 'CheckLimitSuccessMFRootStackBottomCard1', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackBottomSpace0', type: WIDGET.SPACE },
                context !== CONTEXT.VIEW_DETAIL
                    && showEditDetails({ refCode: refCode, context: context })
                    ? { id: 'CheckLimitSuccessMFRootStackBottomCard2', type: WIDGET.STACK }
                    : {}
            ]
        },
        CheckLimitLLABenefitCard: {
            items: [
                {
                    icon: {
                        name: IconTokens.greenPercentage1,
                        size: IconSizeTokens.XXXXL
                    },
                    title: '10.49% per annum (reducing)',
                    subtitle: 'Interest only EMIs'
                },
                {
                    icon: {
                        name: IconTokens.greenClock1,
                        size: IconSizeTokens.XXXXL
                    },
                    title: 'Zero prepayment charges',
                    subtitle: 'Repay or close your loan anytime'
                },
                {
                    icon: {
                        name: IconTokens.greenRupee1,
                        size: IconSizeTokens.XXXXL
                    },
                    title: 'Easily get cash for urgent needs',
                    subtitle: 'while earning interest on your mutual funds'
                },
            ],
            // ctaTitle: 'Withdraw now',
            // availableCreditLimit: availableCreditLimit,
            // ctaAction: {
            //     type: ACTION.APPLY_NOW,
            //     routeId: ROUTE.CHECK_LIMIT_SUCCESS,
            //     payload: {}
            // },
            // enableCta: availableCreditLimit > minAllowedCreditLimit
            enableCta: false
        },
        CheckLimitSuccessMFRootStackBottomCard2: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                all: SizeTypeTokens.LG
            },
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
                borderColor: ColorTokens.Grey_Chalk
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard2Icon1', type: WIDGET.IMAGE },
                { id: 'CheckLimitSuccessMFRootStackBottomCard2Stack1', type: WIDGET.STACK },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard2Stack1: {
            flex: 1,
            padding: {
                left: SizeTypeTokens.LG
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard2Stack1T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard2Stack1Stack1', type: WIDGET.STACK },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard2Stack1Stack1: {
            width: StackWidth.CONTENT,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard2Stack1Stack1T1', type: WIDGET.TEXT }
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.GO_TO_INIT,
                payload: {}
            }
        },
        CheckLimitSuccessMFRootStackBottomCard2Stack1T1: {
            label: `Fetched portfolio for ${pan} / ${phone}`,
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: 24,
            numberOfLines: 2,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard2Stack1Stack1T1: {
            label: 'Edit details >',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            lineHeight: 24,
            color: ColorTokens.Primary_100
        },
        CheckLimitSuccessMFRootStackBottomCard2Icon1: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Fetch_Card_1.png',
            width: 32,
            height: 32
        },
        CheckLimitSuccessMFRootStackBottomCard1: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            padding: {
                all: SizeTypeTokens.XL
            },
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
                borderColor: ColorTokens.Grey_Chalk
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Space0', type: WIDGET.SPACE },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack1', type: WIDGET.STACK },
                eligiblePortfolio ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Divider1', type: WIDGET.DIVIDER } : {},
                eligiblePortfolio ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack2', type: WIDGET.STACK } : {},
                eligiblePortfolio ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack3', type: WIDGET.STACK } : {},
                eligiblePortfolio
                    && showViewDetails({ refCode: refCode, context: context })
                    ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack4', type: WIDGET.STACK }
                    : {},
                nonEligiblePortfolioValue !== 0 ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Divider1', type: WIDGET.DIVIDER } : {},
                nonEligiblePortfolioValue !== 0 ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack5', type: WIDGET.STACK } : {},
                dematPortfolioValue ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack6', type: WIDGET.STACK } : {},
                isLockedPortfolioValue ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack7', type: WIDGET.STACK } : {},
                isUnapprovedPortfolioValue ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8', type: WIDGET.STACK } : {},
                isJointHolderPortfolioValue ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack101', type: WIDGET.STACK } : {},
                nonEligiblePortfolioValue !== 0
                    && showViewDetails({ refCode: refCode, context: context })
                    ? { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack9', type: WIDGET.STACK }
                    : {},
                showWithdrawNowCta({ refCode: refCode, context: context })
                    ? { id: 'CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCtaSpace0', type: WIDGET.SPACE } : {},
                showWithdrawNowCta({ refCode: refCode, context: context })
                    ? { id: 'CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCtaStack1', type: WIDGET.STACK } : {}
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCtaSpace0: {
            size: SizeTypeTokens.XXXL
        },
        CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCtaStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCtaStack2', type: WIDGET.STACK }
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCtaStack2: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            maxWidth: 338,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCta', type: WIDGET.BUTTON }
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCta: {
            type: // availableCreditLimit < minAllowedCreditLimit 
            !eligibleFlag ? ButtonTypeTokens.LargeOutline : ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
            label: 'Continue',
            fontSize: FontSizeTokens.SM,
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: isCheckLimitMFC ? ACTION.GO_TO_REGISTER : ACTION.APPLY_NOW,
                payload: {
                    widgetId: 'CheckLimitSuccessMFRootStackBottomCard1_WithdrawNowCta'
                }
            }
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack9: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack9T1', type: WIDGET.TEXT },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.VIEW_DETAILS,
                payload: {
                    type: PortfolioType.NOT_ELIGIBLE,
                    isFromEligible: false
                }
            }
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack9T1: {
            label: 'View details >',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            lineHeight: 24,
            color: ColorTokens.Primary_100
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8_Unapproved', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack101: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8_jointHolder', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8T101', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8T101: {
            label: `₹${isJointHolderPortfolioValue ? addCommasToNumber(isJointHolderPortfolioValue) : 0}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8T2: {
            label: `₹${isUnapprovedPortfolioValue ? addCommasToNumber(isUnapprovedPortfolioValue) : 0}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8_jointHolder: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8_jointHolder_T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8_Unapproved_Icon', type: WIDGET.IMAGE },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.GO_TO_INFO,
                payload: {
                    title: 'Non eligibility reason',
                    type: CheckLimitInfoType.JOINT_HOLDER
                }
            }
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8_Unapproved: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8_Unapproved_T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack8_Unapproved_Icon', type: WIDGET.IMAGE },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.GO_TO_INFO,
                payload: {
                    title: 'Non eligibility reason',
                    type: CheckLimitInfoType.UNAPPROVED
                }
            }
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8_Unapproved_Icon: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/infoGrey.svg',
            width: 18,
            height: 18,
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8_Unapproved_T1: {
            label: 'Unapproved ',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack8_jointHolder_T1: {
            label: 'Joint holdings',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack7: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack7_Locked', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack7T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack7T2: {
            label: `₹${isLockedPortfolioValue ? addCommasToNumber(isLockedPortfolioValue) : 0}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack7_Locked: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack7_Locked_T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack7_Locked_Icon', type: WIDGET.IMAGE },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.GO_TO_INFO,
                payload: {
                    title: 'Non eligibility reason',
                    type: CheckLimitInfoType.LOCKED
                }
            }
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack7_Locked_T1: {
            label: 'Locked ',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack7_Locked_Icon: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/infoGrey.svg',
            width: 18,
            height: 18,
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack6: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack6_Demat', type: WIDGET.STACK },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack6T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack6_Demat: {
            type: StackType.row,
            width: StackWidth.CONTENT,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack6_Demat_T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack6_Demat_Icon', type: WIDGET.IMAGE },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.GO_TO_INFO,
                payload: {
                    title: 'Non eligibility reason',
                    type: CheckLimitInfoType.DEMAT
                }
            }
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack6_Demat_T1: {
            label: 'Demat ',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack6T2: {
            label: `₹${dematPortfolioValue ? addCommasToNumber(dematPortfolioValue) : 0}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack6_Demat_Icon: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/infoGrey.svg',
            width: 18,
            height: 18,
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack5: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack5T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack5T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack5T1: {
            label: 'Non eligible portfolio',
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack5T2: {
            label: `₹${nonEligiblePortfolioValue ? addCommasToNumber(roundDownToNearestHundred(nonEligiblePortfolioValue)) : 0}`,
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack4: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack4T1', type: WIDGET.TEXT },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.VIEW_DETAILS,
                payload: {
                    type: PortfolioType.ELIGIBLE,
                    isFromEligible: true
                }
            }
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack4T1: {
            label: 'View details >',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '600',
            lineHeight: 24,
            color: ColorTokens.Primary_100
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack3: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack3T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack3T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack3T1: {
            label: 'Eligible limit ',
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack3T2: {
            label: `₹${addCommasToNumber(eligibleLimit)}`,
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Secondary_100
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack2: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                top: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.MD
            },
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack2T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack2T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack2T1: {
            label: 'Eligible portfolio',
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack2T2: {
            label: `₹${addCommasToNumber(eligiblePortfolio)}`,
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard1Divider1: {
            color: ColorTokens.Grey_Chalk,
            size: DividerSizeTokens.MD
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                bottom: SizeTypeTokens.XL
            },
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack1T1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackBottomCard1Stack1T2', type: WIDGET.TEXT },
            ]
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack1T2: {
            label: `₹${addCommasToNumber(totalPortfolio)}`,
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard1Stack1T1: {
            label: 'Total portfolio',
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitSuccessMFRootStackBottomCard1T1: {
            label: 'Credit limit for your portfolio',
            fontSize: _isMobile ? FontSizeTokens.MD : FontSizeTokens.LG,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        ApplyNow: {
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Poppins,
            label: (context === CONTEXT.PARTNER || context === CONTEXT.VIEW_DETAIL)
                ? "Register customer"
                : isLLa({ refCode: refCode })
                    ? "Continue"
                    : "Continue",
            type: // availableCreditLimit < minAllowedCreditLimit 
            !eligibleFlag ? ButtonTypeTokens.LargeOutline : ButtonTypeTokens.LargeFilled,
            width: ButtonWidthTypeToken.FULL,
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: context === CONTEXT.VIEW_DETAIL ? ACTION.GO_TO_REGISTER : ACTION.APPLY_NOW,
                payload: {
                    widgetId: 'ApplyNow',
                    partnerAccountId: partnerAccountId,
                },
            },
        },
        CheckLimitSuccessMFRootStackAvailableLimit: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitSuccessMFRootStackAvailableLimitT1', type: WIDGET.TEXT },
                { id: 'CheckLimitSuccessMFRootStackAvailableLimitInfo', type: WIDGET.IMAGE }
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_SUCCESS,
                type: ACTION.GO_TO_INFO,
                payload: {
                    title: 'How limit is calculated?',
                    type: CheckLimitInfoType.TOTAL_AVAILABLE_LIMIT
                }
            }
        },
        CheckLimitSuccessMFRootStackAvailableLimitT1: {
            label: `₹${availableCreditLimit ? addCommasToNumber(availableCreditLimit) : 0}`,
            fontSize: _isMobile ? FontSizeTokens.XXXXXL : FontSizeTokens.XXXXXXL,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '700',
            lineHeight: 48,
            textAlign: TextAlignTokens.center,
            color: ColorTokens.Secondary_100
        },
        CheckLimitSuccessMFRootStackAvailableLimitInfo: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/info.svg',
            width: 28,
            height: 28
        },
        CheckLimitSuccessMFRootStackTopT1: {
            label: ' 🎉 Congratulations!',
            // label: ' Congratulations!',
            fontSize: _isMobile ? FontSizeTokens.MD : FontSizeTokens.LG,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
            lineHeight: 24,
            textAlign: TextAlignTokens.center
        },
        CheckLimitSuccessMFRootStackTopT2: {
            label: context !== 'PARTNER' ? ' Your available credit limit is' : ' Available credit limit is',
            fontSize: _isMobile ? FontSizeTokens.SM : FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '400',
            lineHeight: 24,
            textAlign: TextAlignTokens.center
        },
        CheckLimitSuccessMFRootStackTopSpace0: {
            size: SizeTypeTokens.XL
        },
        CheckLimitSuccessMFRootStackTopSpace1: {
            size: SizeTypeTokens.XL
        },
        CheckLimitSuccessMFRootStackTopSpace2: {
            size: SizeTypeTokens.XL
        },
        CheckLimitSuccessMFRootStackBottomCard1Space0: {
            size: SizeTypeTokens.XXXL
        },
        CheckLimitSuccessMFRootStackBottomSpace0: {
            size: SizeTypeTokens.XL
        },
        CheckLimitSuccessMFRootStackLessThanAvailableLimitSpace0: {
            size: SizeTypeTokens.XS
        },
        CheckLimitSuccessMFRootStackApplyNowStackSpace0: {
            size: SizeTypeTokens.XL
        },
    }
});
export const CheckLimitSuccessMF = {
    onLoad: async ({ getHeight, asyncStorage, navigate }, { isCheckLimitMFC }) => {
        await initializeFirebase();
        const allowDynamicLimitFromBE = await SharedPropsService?.getFirebaseConfig()?.dynamicCheckLimitFromBE_MFC_check_limit;
        //@ts-expect-error
        const allowDynamicLimitFromBEFlag = allowDynamicLimitFromBE === 'true';
        const partnerAccountId = await sharedPropsService.getPartnerAccountId();
        const customerLeadAssetDetail = await sharedPropsService.getCustomerLeadAssetData();
        const availableCreditLimit = sumObjectValues(customerLeadAssetDetail?.overallSummary?.eligibleCreditLimit);
        const totalPortfolio = sumObjectValues(customerLeadAssetDetail?.overallSummary?.totalFundsSummary);
        const eligiblePortfolio = customerLeadAssetDetail?.overallSummary?.eligibleFundsSummary ? sumObjectValues(customerLeadAssetDetail?.overallSummary?.eligibleFundsSummary) : undefined;
        const eligibleLimit = availableCreditLimit;
        const dematPortfolio = customerLeadAssetDetail?.overallSummary?.nonEligibleFundsSummary[`${NonEligiblePortfolioType.DEMAT}`];
        const isLockedPortfolio = customerLeadAssetDetail?.overallSummary?.nonEligibleFundsSummary[`${NonEligiblePortfolioType.LOCKED}`];
        const isUnapprovedPortolio = customerLeadAssetDetail?.overallSummary?.nonEligibleFundsSummary[`${NonEligiblePortfolioType.UNAPPROVED}`];
        const isJointHolderPortolio = customerLeadAssetDetail?.overallSummary?.nonEligibleFundsSummary?.[`${NonEligiblePortfolioType.JOINT_HOLDER}`];
        const isJointHolderPortfolioValue = isJointHolderPortolio ? (sumObjectValues(isJointHolderPortolio)) : undefined;
        const isEligible = customerLeadAssetDetail?.minimumEligibleLimit?.isEligible;
        const nonEligibleDisplayReason = customerLeadAssetDetail?.minimumEligibleLimit?.nonEligibleDisplayReason;
        const dematPortfolioValue = dematPortfolio ? (sumObjectValues(dematPortfolio)) : undefined;
        const isLockedPortfolioValue = isLockedPortfolio ? (sumObjectValues(isLockedPortfolio)) : undefined;
        const isUnapprovedPortfolioValue = isUnapprovedPortolio ? (sumObjectValues(isUnapprovedPortolio)) : undefined;
        const nonEligiblePortfolioValue = (dematPortfolioValue || 0) + (isLockedPortfolioValue || 0) +
            (isUnapprovedPortfolioValue || 0) + (isJointHolderPortfolioValue || 0);
        ;
        const checkLimitData = JSON.parse(await asyncStorage.get(StoreKey.U_DATA));
        const phone = checkLimitData?.phoneNumber;
        const pan = checkLimitData?.pan;
        await AsyncStorage.setItem("leadData", JSON.stringify(customerLeadAssetDetail));
        const context = await asyncStorage.get(StoreKey.CONTEXT);
        //check if refCode is present in Url
        let refCode = '';
        if (Platform.OS === 'web') {
            const url = window.location.href;
            const params = getParameters(url);
            refCode = params?.ref;
        }
        const eligibleFlag = allowDynamicLimitFromBEFlag ? isEligible : (availableCreditLimit >= minAllowedCreditLimit);
        return Promise.resolve(template(availableCreditLimit, totalPortfolio, eligiblePortfolio, eligibleLimit, dematPortfolioValue, isLockedPortfolioValue, isUnapprovedPortfolioValue, nonEligiblePortfolioValue, phone, pan, partnerAccountId, context, refCode, isCheckLimitMFC, isEligible, nonEligibleDisplayReason, allowDynamicLimitFromBEFlag, eligibleFlag, isJointHolderPortfolioValue));
    },
    actions: {
        [ACTION.VIEW_DETAILS]: goToViewDetails,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.GO_TO_INIT]: goToInit,
        [ACTION.GO_TO_INFO]: goToInfo,
        [ACTION.APPLY_NOW]: applyNow,
        [ACTION.GO_TO_REGISTER]: goToRegisterLeads,
    },
};
